import { createContext, useContext } from 'react';

// "Ver como X vê": a preview of what another member sees. The API already withholds payer-only details from
// everyone else, so the preview only has to hide what THIS person gets on top: every `data-private` node.
export const SpacePartnerPreviewContext = createContext<{
  viewerId: string | null;
  // True only when the preview is what took actions away: the person is an editor of an open space. A viewer, or
  // anyone in a closed space, had none to begin with, and the notices must keep giving THAT reason.
  actionsHidden: boolean;
  preview: (userId: string | null) => void;
}>({ viewerId: null, actionsHidden: false, preview: () => undefined });

export const PREVIEW_ACTIONS_NOTICE = 'As suas ações ficam guardadas enquanto a prévia está aberta.';

// True while a partner preview is the reason the space below reads as read-only, so the notices that explain
// read-only access name the preview. It stays false when the real reason would outlive the preview (a closed
// space, a viewer's role): those notices must not promise actions that closing the preview will not bring back.
export function useSpaceActionsHidden(): boolean {
  return useContext(SpacePartnerPreviewContext).actionsHidden;
}

export function useSpacePartnerPreview() {
  return useContext(SpacePartnerPreviewContext);
}

// Whose point of view a space page speaks from ("você", "sua parte", the viewer's balance and transfers first): the
// member being previewed, otherwise the signed-in person (ruled 2026-09-24). Display only: drafts, storage keys,
// permissions and writes always keep the signed-in id, and the payer-only facts this client holds stay blurred.
export function useSpacePerspective(userId: string): string {
  return useContext(SpacePartnerPreviewContext).viewerId ?? userId;
}
